<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
       {{label}}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-row class="pt-2">

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_sex"
            :items="$store.getters.get_Sex"
            item-text="sex_name"
            item-value="sex_id"
            label="เพศ"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.pre_id"
            :items="Computed_PreName"
            item-text="pre_prename"
            item-value="pre_id"
            label="คำนำหน้า"
          ></v-select>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            label="ชื่อ"
            v-model="$store.state.dataFrm.tea_fname"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            label="นามสกุล"
            v-model="$store.state.dataFrm.tea_lname"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            label="Name"
            v-model="$store.state.dataFrm.tea_fname_en"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            label="Surname"
            v-model="$store.state.dataFrm.tea_lname_en"
          ></v-text-field>
        </v-col>

        <!-- 
        <v-col cols="12" md="4" class="pt-0 pb-0">
          <datetimepicker_TH
            label="วันเดือนปีเกิด (ผู้สมัคร)"
            :dateTH="$store.state.dataFrm.tea_birthday"
            @callBackValue="(val) => ($store.state.dataFrm.tea_birthday = val)"
          ></datetimepicker_TH>
        </v-col> 
        -->

        <v-col cols="12" md="4" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_address"
            label="ที่อยู่"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_province"
            :items="$store.getters.get_Province"
            item-text="pro_name"
            item-value="pro_code"
            label="จังหวัด"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_district"
            :items="
              $store.getters.get_District({
                pro_id: $store.state.dataFrm.tea_province,
              })
            "
            item-text="dis_name"
            item-value="dis_id"
            label="อำเภอ"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_locality"
            :items="
              $store.getters.get_Locality({
                pro_id: $store.state.dataFrm.tea_province,
                dis_id: $store.state.dataFrm.tea_district,
              })
            "
            item-text="loc_name"
            item-value="loc_id"
            label="ตำบล"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_post_code"
            label="รหัสไปรษณีย์"
            maxlength="5"
            counter="5"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_phone"
            label="เบอร์โทร"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_mobile"
            label="เบอร์มือถือ"
            maxlength="10"
            counter="10"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_blood"
            :items="$store.getters.get_Blood"
            item-text="bl_name"
            item-value="bl_id"
            label="กรุ๊ปเลือด"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_race"
            :items="$store.getters.get_Nation"
            item-text="nt_name"
            item-value="nt_id"
            label="สัญชาติ"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_nationality"
            :items="$store.getters.get_Nation"
            item-text="nt_name"
            item-value="nt_id"
            label="เชื่อชาติ"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-select
            v-model="$store.state.dataFrm.tea_religion"
            :items="$store.getters.get_Religion"
            item-text="rel_name"
            item-value="rel_id"
            label="ศาสนา"
          ></v-select>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_tall"
            label="ส่วนสูง (เซนติเมตร)"
            type="number"
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="2" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.tea_weight"
            label="น้ำหนัก (กิโลกรัม)"
            type="number"
          ></v-text-field>
        </v-col>

      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
      tea_birthday: "",
      tea_sex: "",
    };
  },
   props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    Computed_PreName(){
      // return this.$store.getters.get_PreName.filter(val=>val.pre_id==='01')
      if(this.$store.state.dataFrm.tea_sex==='M'){
        return this.$store.getters.get_PreName.filter(val=>val.pre_id==='01')
      }
      else {
        return this.$store.getters.get_PreName.filter(val=>val.pre_id==='02'||val.pre_id==='03')
      }
      
    },
  },
};
</script>

<style lang=""></style>
